import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { PanelCustomFieldContainer } from "./PanelCustomFieldContainer";
export const PublicAssetPanelCustomFieldContainer = /*#__PURE__*/ memo((params)=>{
    return /*#__PURE__*/ _jsx(PanelCustomFieldContainer, {
        canDeleteCustomFields: false,
        canEditCustomFields: false,
        ...params
    });
});
PublicAssetPanelCustomFieldContainer.displayName = "PublicAssetPanelCustomFieldContainer";
